import { createContext, useContext } from 'react'

/**
 * Bridge so deeply-nested onboarding UI (e.g. the readiness questionnaire's
 * per-question "Ask Vera" buttons) can open the WIZARD's chat rail.
 *
 * On full-screen onboarding routes the GLOBAL assistant panel
 * (`screenataAssistantOpenAtom` / `useAskAi`) is intentionally hidden
 * (see workspaces/route.tsx) — the wizard hosts its own rail whose open
 * state is LOCAL React state in OnboardingWizard, not an atom. So a child
 * can't open it by toggling an atom; it must call through this context.
 *
 * When this context is absent (e.g. ReadinessQuestionnaireRow rendered
 * inside the PolicyQuestionnaireDialog, outside onboarding), callers fall
 * back to `useAskAi`, which drives the global panel that IS mounted there.
 */
export interface OnboardingAssistantApi {
  /** Open the wizard chat rail and seed it with a message + context. */
  askVera: (args: { text: string; data?: Record<string, unknown> }) => void
}

export const OnboardingAssistantContext =
  createContext<OnboardingAssistantApi | null>(null)

export function useOnboardingAssistant(): OnboardingAssistantApi | null {
  return useContext(OnboardingAssistantContext)
}
